import { useState } from "react";
import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";
import { formRender, initialValues, countryValidations } from "./country-schema";
import CountryInfo from "./components/CountryInfo";
import { useMutation } from "@tanstack/react-query";
import { createCountry } from "services/data.internal.service";
import { Success, Error_ } from "ui-components/Alert";

function AddCountry() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createCountryMutation = useMutation(createCountry, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({ defaultValues: initialValues, resolver: yupResolver(countryValidations) });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = form;

  const infoProps = { formRender, control, errors };

  const onSubmit = (data) => {
    createCountryMutation.mutate(data, { onSuccess: () => reset() });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CountryInfo {...infoProps} />
        <SubmitButton label="Submit" disabled={isSubmitting} url="/setup/country" />
      </form>
    </Layout>
  );
}

export default AddCountry;
